import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./App.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { Routes, Route, Navigate } from "react-router-dom";

import NavBar from "./components/navbar";
import Heroes from "./components/hero";
import BookingToast from "./components/bookingtoast";
import FaqSection from "./components/faq";
import ContactForm from "./components/contact";
import Gallery from "./components/gallery";
import Services from "./components/services";
import ScrollToTop from "./components/scrolltop";
import Doctors from "./components/doctors";
import Seo from "./components/Seo";
import ServicePage from "./components/ServicePage";
import Impresszum from "./components/Impresszum";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CookieConsent from "./components/CookieConsent";

/* ---------------- HOME PAGE ---------------- */

function HomePage() {
  return (
    <>
      <Seo
        title="Fogorvosszolnok.hu Fogászat Szolnok | Modern fogászati kezelések"
        description="Fogorvosszolnok.hu Fogászat Szolnokon – modern eszközök, tapasztalt fogorvosok, barátságos környezet. Online időpontfoglalás."
        canonical="https://fogorvosszolnok.hu/"
      />

      <Heroes />
      <Gallery />
      <Services />
      <Doctors />
      <FaqSection />
    </>
  );
}

/* ---------------- APP ROOT ---------------- */

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <NavBar />

      <Routes>
      
        <Route path="/" element={<HomePage />} />

        
        <Route path="/szolgaltatasok/:slug" element={<ServicePage />} />
        
        <Route path="/impresszum" element={<Impresszum />} />
        <Route
          path="/adatvedelmi-tajekoztato"
          element={<PrivacyPolicy />}
        />

        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <CookieConsent />
      <ContactForm />
      <BookingToast />
    </div>
  );
}

export default App;
